<template>
  <el-dialog align-center v-model="state.dialogVisible" :title="t('attendanceDialog.annualLeaveAuditTitle')" width="680" draggable>
    <el-form label-width="110px">
      <el-form-item :label="t('field.realName')">{{ rowInfo?.name || '-' }}</el-form-item>
      <el-form-item :label="t('attendance.leaveType')">
        {{ rowInfo?.leave_type === 'annual_leave' ? t('attendanceDialog.leaveTypeAnnual') : t('attendanceDialog.leaveTypeNormal') }}
      </el-form-item>
      <el-form-item :label="t('attendanceDialog.timeRange')">{{ rowInfo?.start_date }} ~ {{ rowInfo?.end_date }}</el-form-item>
      <el-form-item :label="t('attendance.days')">{{ rowInfo?.leave_days || 0 }}</el-form-item>
      <el-form-item :label="t('attendance.reason')">{{ rowInfo?.reason || '-' }}</el-form-item>
      <el-form-item :label="t('attendanceDialog.auditRemark')">
        <el-input v-model="state.form.remark" type="textarea" :rows="3" :placeholder="t('attendanceDialog.auditRemarkPlaceholder')" />
      </el-form-item>
      <el-form-item :label="t('attendanceDialog.auditResult')">
        <el-radio-group v-model="state.form.action">
          <el-radio :label="auditAction.pass">{{ t('attendance.pass') }}</el-radio>
          <el-radio :label="auditAction.reject">{{ t('attendance.reject') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="state.dialogVisible=false">{{ t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ t('common.confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, ref, defineEmits, defineExpose } from 'vue'
import { ElMessage } from 'element-plus'
import { auditApi } from '@/api/attendance/annualLeave'
import { isTenantAdminRole } from '@/utils/adminMenuPermission.js'
import { usePageI18n, t } from '@/composables/usePageI18n.js'

const emit = defineEmits(['refresh'])
const rowInfo = ref(null)
const userInfo = JSON.parse(localStorage.getItem('user') || '{}')
const currentUser = userInfo?.users || userInfo?.user?.users || userInfo || {}
const roleId = Number(currentUser?.roleId || currentUser?.role_id || 0)
const userId = Number(currentUser?.id || 0)
const isAdmin = computed(() => isTenantAdminRole(roleId))

const state = reactive({
  dialogVisible: false,
  form: { id: 0, action: 'captain_pass', remark: '' },
})

const auditAction = computed(() => isAdmin.value
  ? { pass: 'admin_pass', reject: 'admin_reject' }
  : { pass: 'captain_pass', reject: 'captain_reject' })

const open = (row) => {
  rowInfo.value = row
  state.dialogVisible = true
  state.form.id = row.id
  state.form.remark = ''
  state.form.action = auditAction.value.pass
}

const submit = () => {
  if (!userId) return ElMessage.error(t('attendanceDialog.reloginRequired'))
  auditApi(JSON.stringify({
    id: state.form.id,
    auditor_id: userId,
    action: state.form.action,
    remark: state.form.remark || '',
  })).then((res) => {
    if (res?.code === 200) {
      ElMessage.success(t('attendanceDialog.auditSuccess'))
      state.dialogVisible = false
      emit('refresh')
    } else {
      ElMessage.error(res?.msg || t('attendanceDialog.auditFailed'))
    }
  })
}

usePageI18n(() => {});

defineExpose({ open })
</script>
